function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "9BC7AB8E-55B4-4E7B-83E4-303EF00CD3A7");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Permatrol",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Responsive_1",
  transform: "translate(-16.000000, -2403.000000)",
  stroke: "#22252D",
  strokeWidth: 2
}, React.createElement("g", {
  id: "Group-14",
  transform: "translate(11.000000, 2278.000000)"
}, React.createElement("g", {
  id: "horario",
  transform: "translate(6.000000, 126.000000)"
}, React.createElement("circle", {
  id: "Oval",
  cx: 7.5,
  cy: 7.5,
  r: 7.5
}), React.createElement("polyline", {
  id: "Path-3",
  points: "6.8811719 3.1415007 6.8811719 8.13391893 10.885089 8.13391893"
})))));

var SvgFtClock = function SvgFtClock(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFtClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ft-clock.066ac6ce.svg";
export { ForwardRef as ReactComponent };